<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Vertrek</p>
            <hr>
        </div>
        <div>
            <p class="h4 text-center">
                Intro
            </p>
            <hr>
            <p class="text-center d-block margin">
                Heb je er een beetje zin in? Tijdens deze wandeling krijg je een paar weetjes over chiro Bloemendaal voorgeschoteld. Maar we willen je vooral de kans geven om wat eigen chiroverhalen op te halen. Wat vind jij zo leuk aan de chiro? 
            </p>
            <div class="text-center">
                <p class="text-center d-block margin">
                    Zullen we al meteen beginnen? Tijdens dit eerste stuk van de wandeling mag je aan je medewandelaars vertellen over het allereerste waar je aan denkt als je het woord ‘chiro’ hoort. Een leuk spelletje, een plek, een kampherinnering… Wat komt er als eerste in je op? Wat was het leukste dat je ooit meemaakte in de chiro?            
                </p>
                <!-- https://chiro.be/sites/default/files/2018-03/Chirologo_1200px.png -->
                <img src="https://chiro.be/sites/default/files/2018-03/Chirologo_1200px.png" alt="ChiroLogo.png">
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Wandel intussen via de Jozef Jennesstraat naar de Kopstraat. Sla daar rechtsaf naar de Zeurt. Sla vervolgens linksaf de Eksterdreef in. Volg die tot net voorbij de weide voorbij het skatepark. Daar wandel je via het groene poortje het bos in.            
            </p>
        </div>
    </div>
    <div class="text-center buttonBottom">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte1'">Volgende stop<br>(Gewone route)</button>
    </div>
    <div class="textBlock">
        <div>
            <p class="h5 text-center">
                Buggyroute
            </p>
            <hr>
            <p class="text-center d-block margin">
                Ben je met de buggy? Dan is dit stukje wandeling door het bos een hele uitdaging. Ga je die liever niet aan? Dan kan je ook een stukje van de wandeling overslaan. Wandel dan aan het groene poortje rechtdoor en sla een eindje verder rechtsaf de Zeurtebaan in.
            </p>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte2'">Volgende stop<br>(Buggyroute)</button>
    </div>
</div>